import { isOrgProfile, OrgProfile } from '~/modules/appx_site_schema';
import { APPX_SITE_API_URL } from '~/modules/config';
import { handleException } from '~/modules/utilities/error_utilities';
import { http } from '~/modules/utilities/http';

/**
 * Fetches an org's tenant metadata (industry/region/products) via the appx-site-server proxy.
 * Degrades to null (never throws) on any failure or a malformed body, validated with isOrgProfile,
 * so org selection still succeeds and the homepage just skips personalization.
 */
export class OrgProfileService {
    async getOrgProfile(orgId: string): Promise<OrgProfile | null> {
        try {
            const response = await http.get(`${APPX_SITE_API_URL}/experience/orgs/${orgId}/profile`);
            return isOrgProfile(response.data) ? response.data : null;
        } catch (error) {
            handleException(error, 'orgProfileService.getOrgProfile');
            return null;
        }
    }
}
